import { Injectable } from '@angular/core'
import { BaseModelService } from './base-model.service'
import { NotificationSerializer } from 'serializers'
import { Notification } from "./notification.model";
import { Observable } from "rxjs/Observable";

@Injectable()
export class NotificationService extends BaseModelService<Notification> {
  constructor() {
    super()

    this.configure({
      basePath:  'notifications',
      key:       'notification',
      pluralKey: 'notifications',
      serializer: NotificationSerializer
    })
  }

  readNotifications(notifications: Notification[]): Observable<Object> {
    let url = this.buildUrl('read_notifications')
    let params = {
      notification_ids: notifications.map(notification => notification.id)
    }
    let body = JSON.stringify(params)

    return this.appHttp.post(url, body)
               .map((response) => this.processResponse(response))
  }

  unreadedNotificationsInfo(): Observable<Object> {
    let url = this.buildUrl('info')

    return this.get(url, {})
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/notification.service.ts